// 3rd Party
import React from 'react';
import PropTypes from 'prop-types';

// Components
import { MultiFloatingInputRow } from '../../../checkout-styled-components';
import FloatingInput from '../../../../common/components/FloatingInput/FloatingInput';

// Component
export const NameFormRow = ({ prefix, firstName, lastName, onChange }) => (
  <MultiFloatingInputRow itemcount={2} tabIndex={-1} aria-label="Name">
    {/* prefix determines whether this input is for the user vs. the name of an insurance holder (memberfirstName) */}
    <FloatingInput
      className="sensitive-data"
      field={`${prefix}firstName`}
      label="First Name"
      message="Required"
      required
      testId={`${prefix}firstNameInput`}
      initialValue={firstName}
      onChange={e => onChange('firstName', e.target.value)}
    />
    {/* prefix determines whether this input is for the user vs. the name of an insurance holder (memberlastName) */}
    <FloatingInput
      className="sensitive-data"
      field={`${prefix}lastName`}
      label="Last Name"
      message="Required"
      required
      testId={`${prefix}lastNameInput`}
      initialValue={lastName}
      onChange={e => onChange('lastName', e.target.value)}
    />
  </MultiFloatingInputRow>
);

NameFormRow.defaultProps = {
  prefix: '',
};

NameFormRow.propTypes = {
  prefix: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
